import script from "./ACircularImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ACircularImage.vue?vue&type=script&setup=true&lang=ts"

import "./ACircularImage.vue?vue&type=style&index=0&id=442dc76c&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442dc76c"]])

export default __exports__